/* Pack links retain their normal destinations as the no-JavaScript/error fallback. */
(() => {
  if (window.pbPackSwitchInstalled) return;
  const first = document.querySelector('[data-pb-pack-switch]');
  if (!first) return;
  window.pbPackSwitchInstalled = true;
  const section = first.closest('.shopify-section');
  const sectionId = first.dataset.section;
  const records = new Map();
  let active, pending, fallbackUrl, running = false, intent = 0;
  const picker = () => section.querySelector('[data-pb-pack-switch]');
  const form = () => section.querySelector('product-form form');
  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
  const destination = href => {
    const url = new URL(href, location.href);
    const current = new URL(location.href);
    for (const [key, value] of current.searchParams) {
      if (key === 'preview_theme_id' || key === 'igTg' || key.startsWith('ig-') || key === 'pb_25_pack_price') url.searchParams.set(key, value);
    }
    url.searchParams.delete('section_id');
    return url;
  };
  const keyOf = url => `${url.pathname}?view=${url.searchParams.get('view') || ''}&variant=${url.searchParams.get('variant') || ''}`;
  const readChoice = () => {
    const currentForm = form();
    const delivery = currentForm?.querySelector('.loop-selling-plan-selector-option:checked');
    return {
      subscription: Boolean(currentForm?.querySelector('[name="selling_plan"]')?.value),
      plan: delivery?.value,
      frequency: delivery ? currentForm.querySelector(`label[for="${delivery.id}"]`)?.textContent.trim() : '',
      quantity: currentForm?.querySelector('[name="quantity"]')?.value || '1'
    };
  };
  const sync = () => {
    const currentForm = form();
    if (!currentForm) return;
    const subscription = Boolean(currentForm.querySelector('[name="selling_plan"]')?.value);
    picker()?.querySelector('.pocobero-pack-grid')?.classList.toggle('is-subscription', subscription);
    currentForm.querySelectorAll('[name="loop_purchase_option"]').forEach(radio => {
      const group = radio.closest('.loop-subscription-group');
      const plans = group?.querySelector('.loop-subscription-group-selling-plans-container');
      if (plans) plans.style.display = radio.checked ? '' : 'none';
      const card = radio.closest('.loop-one-time-purchase-option, .loop-selling-plan-allocation');
      if (card) {
        card.style.setProperty('background', radio.checked ? '#f5f3ec' : '#fff', 'important');
        card.style.setProperty('border', radio.checked ? '2px solid #081418' : '1px solid #cad0cf', 'important');
      }
    });
  };
  const restoreChoice = choice => {
    const currentForm = form();
    const options = [...currentForm.querySelectorAll('.loop-selling-plan-selector-option')];
    const selectedPlan = options.find(el => el.value === choice.plan) || options.find(el => currentForm.querySelector(`label[for="${el.id}"]`)?.textContent.trim() === choice.frequency);
    const radio = currentForm.querySelector(choice.subscription ? '.loop-subscription-group-radio' : '.loop-one-time-purchase-option-radio');
    if (!radio) throw new Error('Purchase option unavailable');
    radio.click();
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    if (selectedPlan) {
      selectedPlan.checked = true;
      selectedPlan.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const quantity = currentForm.querySelector('[name="quantity"]');
    if (quantity) quantity.value = choice.quantity;
    sync();
    if (Boolean(currentForm.querySelector('[name="selling_plan"]')?.value) !== choice.subscription) throw new Error('Purchase option did not initialize');
  };
  const busy = value => {
    section.dataset.packSwitchBusy = String(value);
    const widget = section.querySelector('.loop-subscription-container');
    if (widget) widget.inert = value;
    picker()?.setAttribute('aria-busy', String(value));
    // The selector remains interactive so a later click can supersede an earlier one.
    section.querySelectorAll('button[type="submit"], .pocobero-sticky-atc__btn').forEach(button => {
      if (value) {
        if (!button.hasAttribute('data-pb-was-disabled')) button.dataset.pbWasDisabled = String(button.disabled);
        button.disabled = true;
      } else if (button.hasAttribute('data-pb-was-disabled')) {
        button.disabled = button.dataset.pbWasDisabled === 'true';
        delete button.dataset.pbWasDisabled;
      }
    });
    const status = section.querySelector('[data-pb-pack-status]');
    if (status) status.textContent = value ? picker().dataset.loadingLabel : '';
  };
  const fetchRecord = url => {
    const key = keyOf(url);
    if (records.has(key)) return records.get(key);
    const request = new URL(url);
    request.searchParams.set('section_id', sectionId);
    const promise = fetch(request, { signal: AbortSignal.timeout(10000) }).then(async response => {
      if (!response.ok) throw new Error('Unable to load pack');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const container = doc.querySelector('.container');
      const incoming = container?.querySelector('[data-pb-pack-switch]');
      const productForm = container?.querySelector('product-form form');
      if (!incoming || !productForm?.querySelector('[name="id"]') || incoming.dataset.layout !== first.dataset.layout) throw new Error('Unexpected pack response');
      return { container, ready: false, url };
    }).catch(error => { records.delete(key); throw error; });
    records.set(key, promise);
    return promise;
  };
  const setPosition = top => {
    const next = picker();
    if (next) window.scrollBy({ top: next.getBoundingClientRect().top - top, behavior: 'instant' });
  };
  const updateSticky = () => {
    const wrap = section.querySelector('.pocobero-sticky-atc');
    const target = wrap && section.querySelector(wrap.dataset.target);
    if (target) wrap.classList.toggle('is-visible', target.getBoundingClientRect().bottom < 0);
  };
  const prefetch = () => {
    if (navigator.connection?.saveData) return;
    picker()?.querySelectorAll('a.pocobero-pack-card').forEach(link => {
      const url = destination(link.href);
      if (url.origin === location.origin) fetchRecord(url).catch(() => {});
    });
  };
  const track = () => {
    const data = section.querySelector('script[class^="loopProductQuickJson-"]');
    if (!data) return;
    const product = JSON.parse(data.textContent);
    const variant = product.variants.find(v => String(v.id) === form().querySelector('[name="id"]').value);
    document.title = `${product.title} – Poco Bero`;
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = `${location.origin}${location.pathname}`;
    document.dispatchEvent(new CustomEvent('pocobero:pack-change', { detail: { productId: product.id, variantId: variant?.id, url: location.href } }));
    window.item = { Name: product.title, ProductID: product.id, ImageURL: product.featured_image, URL: location.href, Brand: product.vendor, Price: (variant?.price || product.price) / 100 };
    window._learnq?.push(['track', 'Viewed Product', window.item]);
  };
  const process = async () => {
    if (running) return;
    running = true;
    const choice = readChoice();
    busy(true);
    try {
      while (pending) {
        const request = pending;
        fallbackUrl = request.url;
        pending = null;
        let record;
        try { record = await fetchRecord(request.url); }
        catch (error) { if (request.id !== intent) continue; throw error; }
        if (request.id !== intent) continue;
        const top = picker().getBoundingClientRect().top;
        const current = section.querySelector('.container');
        const previous = active;
        active = record;
        current.replaceWith(record.container);
        busy(true);
        // Loop reads the URL variant while it initializes. Replace history only once ready.
        history.replaceState(history.state, '', request.url);
        setPosition(top);
        try {
          if (!record.ready) {
            const productId = form().dataset.loopProductId;
            if (typeof window.initLoopWidget !== 'function') throw new Error('Subscriptions not ready');
            await Promise.race([window.initLoopWidget(Number(productId)), delay(8000).then(() => { throw new Error('Subscription initialization timed out'); })]);
            // Loop has delayed 300/500ms default-selection callbacks; settle them before restoring the shopper's choice.
            await delay(550);
            if (section.querySelector('.loop-subscription-container')?.classList.contains('loop-display-none')) throw new Error('Subscription widget unavailable');
            record.ready = true;
          }
          restoreChoice(choice);
          setPosition(top);
          updateSticky();
          if (request.id === intent) {
            picker().querySelector('a[aria-selected="true"]')?.focus({ preventScroll: true });
            section.dataset.packSwitchCount = String(Number(section.dataset.packSwitchCount || 0) + 1);
            track();
          }
        } catch (error) {
          record.container.replaceWith(previous.container);
          active = previous;
          throw error;
        }
      }
    } catch (error) {
      // Preserve functional product links if section rendering or the app fails.
      const target = pending?.url || fallbackUrl || active.url;
      location.assign(target);
    } finally {
      busy(false);
      running = false;
    }
  };
  active = { container: section.querySelector('.container'), ready: true, url: new URL(location.href) };
  const initialLink = picker().querySelector('a[aria-selected="true"]');
  records.set(keyOf(destination(initialLink?.href || location.href)), Promise.resolve(active));
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-pb-pack-switch] a.pocobero-pack-card');
    if (!link || !section.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = destination(link.href);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!running && link.getAttribute('aria-selected') === 'true') return;
    pending = { url, id: ++intent };
    fetchRecord(url).catch(() => {});
    process();
  }, true);
  document.addEventListener('submit', event => {
    if (running && section.contains(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  section.addEventListener('change', () => { sync(); });
  section.addEventListener('click', event => {
    if (event.target.closest('.pocobero-sticky-atc__btn')) section.querySelector('[id^="ProductSubmitButton-"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (event.target.closest('.loop-subscription-group')) setTimeout(sync, 0);
  });
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  // Preserve the existing replaceState history behavior; Back still returns to the preceding page.
  const preload = () => { sync(); prefetch(); };
  if (document.readyState === 'complete') preload();
  else window.addEventListener('load', preload, { once: true });
})();
